import { useState } from "react";
import Header from "../../header/Header";
import FadeIn from "../../../general/FadeIn";
import RoundedInput from "../../../general/RoundedInput";
import DateInput from "../../../general/DateInput";
import OrangeButton from "../../../general/OrangeButton";
import FalecidoDocumentsManager from "../../../general/FalecidoDocumentsManager";
import Api from "../../../../services/Api";

const labelStyle = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
  fontWeight: 600,
  color: "#888",
  marginBottom: 4,
  paddingLeft: 12,
  display: "block",
};

function RegisterBuriedPage({ navigate, user, onLogout, selectedFalecido }) {
  const [form, setForm] = useState({
    nome_completo: selectedFalecido?.nome_completo || "",
    data_nascimento: selectedFalecido?.data_nascimento || "",
    data_falecimento: selectedFalecido?.data_falecimento || "",
    nome_pai: selectedFalecido?.nome_pai || "",
    nome_mae: selectedFalecido?.nome_mae || "",
    causa_morte: selectedFalecido?.causa_morte || "",
    medico_responsavel: selectedFalecido?.medico || "",
    apelido: selectedFalecido?.apelido || "",
    registrado: false,
    mensagem_familia: selectedFalecido?.mensagem_familia || "",
    observacoes: selectedFalecido?.observacoes || "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const update = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleVoltar = () => navigate("search", { selectedFalecido });

  const handleSubmit = async () => {
    setError("");
    if (!form.nome_completo || !form.data_falecimento) {
      setError("Nome completo e data de falecimento são obrigatórios.");
      return;
    }
    setLoading(true);
    try {
      await Api.updateBuried(selectedFalecido.id, {
        nome_completo: form.nome_completo,
        data_nascimento: form.data_nascimento || null,
        data_falecimento: form.data_falecimento,
        nome_pai: form.nome_pai || null,
        nome_mae: form.nome_mae || null,
        apelido: form.apelido || null,
        causa_morte: form.causa_morte || null,
        medico_responsavel: form.medico_responsavel || null,
        mensagem_familia: form.mensagem_familia || null,
        observacoes: form.observacoes || null,
      });
      const updated = await Api.getFalecidosPorId(selectedFalecido.id);
      navigate("search", { selectedFalecido: updated || selectedFalecido });
    } catch (e) {
      setError(e.message || "Erro ao atualizar falecido.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#fafafa",
      }}
    >
      <Header
        onHome={() => navigate("search")}
        onLogin={() => navigate("login")}
        user={user}
        onLogout={onLogout}
        navigate={navigate}
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
        }}
      >
        <FadeIn delay={100}>
          <h1
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 32,
              fontWeight: 700,
              color: "#2d2d2d",
              textAlign: "center",
              marginBottom: 36,
            }}
          >
            Atualizar Falecido
          </h1>
        </FadeIn>

        <div
          style={{
            width: "100%",
            maxWidth: 400,
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <FadeIn delay={200}>
            <RoundedInput
              placeholder="Nome completo *"
              value={form.nome_completo}
              onChange={update("nome_completo")}
            />
          </FadeIn>

          <FadeIn delay={260}>
            <RoundedInput
              placeholder="Apelido"
              value={form.apelido}
              onChange={update("apelido")}
            />
          </FadeIn>

          <FadeIn delay={320}>
            <div lang="pt-BR">
              <label style={labelStyle}>Data de nascimento</label>
              <DateInput
                value={form.data_nascimento}
                onChange={update("data_nascimento")}
              />
            </div>
          </FadeIn>

          <FadeIn delay={380}>
            <div lang="pt-BR">
              <label style={labelStyle}>Data de falecimento *</label>
              <DateInput
                value={form.data_falecimento}
                onChange={update("data_falecimento")}
              />
            </div>
          </FadeIn>

          <FadeIn delay={440}>
            <RoundedInput
              placeholder="Nome do pai"
              value={form.nome_pai}
              onChange={update("nome_pai")}
            />
          </FadeIn>

          <FadeIn delay={500}>
            <RoundedInput
              placeholder="Nome da mãe"
              value={form.nome_mae}
              onChange={update("nome_mae")}
            />
          </FadeIn>

          <FadeIn delay={560}>
            <RoundedInput
              placeholder="Causa da morte"
              value={form.causa_morte}
              onChange={update("causa_morte")}
            />
          </FadeIn>

          <FadeIn delay={620}>
            <RoundedInput
              placeholder="Médico responsável"
              value={form.medico_responsavel}
              onChange={update("medico_responsavel")}
            />
          </FadeIn>

          <FadeIn delay={680}>
            <RoundedInput
              placeholder="Mensagem da família"
              value={form.mensagem_familia}
              onChange={update("mensagem_familia")}
            />
          </FadeIn>

          <FadeIn delay={720}>
            <RoundedInput
              placeholder="Observações"
              value={form.observacoes}
              onChange={update("observacoes")}
            />
          </FadeIn>

          <FadeIn delay={760}>
            <FalecidoDocumentsManager falecidoId={selectedFalecido?.id} />
          </FadeIn>

          <FadeIn delay={800}>
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <OrangeButton onClick={handleSubmit} disabled={loading}>
                {loading ? "Atualizando..." : "Atualizar"}
              </OrangeButton>
              {error && (
                <p
                  style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: 13,
                    color: "#e53935",
                    marginTop: 10,
                  }}
                >
                  {error}
                </p>
              )}
              <p
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 13,
                  color: "#999",
                  marginTop: 12,
                }}
              >
                (* Campos obrigatórios)
              </p>
              <p
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 14,
                  color: "#E8956A",
                  marginTop: 16,
                  cursor: "pointer",
                }}
                onClick={handleVoltar}
              >
                Voltar
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </div>
  );
}

export default RegisterBuriedPage;
